import React from 'react';
import { useTranslate } from '@/translations';
import { useAppCustomers } from '@/hooks';
import {
  NoAccessAlert,
  PageContainer,
  Title,
  faShieldHalved,
} from '@/ui/components';
import { Card } from 'antd';
import { AccessRulesDataGrid } from './components/AccessRulesDataGrid';

export const AdminInspectionStatusAccessRules: React.FC = () => {
  const { t } = useTranslate();
  const { hasSuperAdminAccess } = useAppCustomers();

  if (!hasSuperAdminAccess) {
    return <NoAccessAlert />;
  }

  return (
    <PageContainer>
      <Title title={t('inspectionStatusAccessRules')} icon={faShieldHalved} />

      <Card>
        <AccessRulesDataGrid />
      </Card>
    </PageContainer>
  );
};
